module.exports = __webpack_public_path__ + "assets/img/media_13.b3930bb4.png";